import { render, staticRenderFns } from "./chat_list.vue?vue&type=template&id=c446cbf0&scoped=true&"
import script from "./chat_list.vue?vue&type=script&lang=js&"
export * from "./chat_list.vue?vue&type=script&lang=js&"
import style0 from "./chat_list.vue?vue&type=style&index=0&id=c446cbf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c446cbf0",
  null
  
)

export default component.exports